$(function () {

    // Beat fragen

    // on page load
    function initSpecialRadioWidget() {
        let $event_form = $('.event-register-form');
        let $is_client = $event_form.find('#id_is_client');
        $($is_client).on('click', function (e) {
            let $billing_address = $('.event-register-form__billing-address');
            if (this.checked) {
                $billing_address.hide();
                $billing_address.find(':input').each(function () {
                    let $this = $(this);
                    $this.prop('required', false);
                    $this.removeClass('required');
                });
            } else {
                $billing_address.show();
                $billing_address.find(':input').each(function () {
                    let $this = $(this);
                    $this.prop('required', true);
                    $this.addClass('required');
                });
            }
        });
    }

    // on page load
    initSpecialRadioWidget();


    // re-init when softpage has been opened
    $(window).on('form-modal:opened initAjaxForm', function (e) {
        initSpecialRadioWidget();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/events.js